import React from "react";
import { SiWix, SiWordpress, SiSquarespace, SiShopify, SiWoocommerce, SiMailchimp } from "react-icons/si";
import { MessageSquare, Search, Star } from "lucide-react";
import { FaEnvelopeOpenText, FaChartLine } from "react-icons/fa"; // Safe fallback icons

export default function WebsiteDesignAddOns() {
  return (
    <section className="bg-[#F6F3F1] py-6 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-5xl  text-gray-900 mb-4">Enhance Your Website Package</h2>
        <p className="text-gray-700 max-w-2xl mx-auto mb-12">
          These add-ons are perfect for elevating your Website Glow-Up or Pro package. Mix and match to create a complete, high-converting online presence.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

          {/* Foundational Web Design */}
          <div className="bg-white p-8 text-left shadow-sm border border-gray-200">
            <h3 className="uppercase text-sm text-[#517d74] tracking-widest mb-3">Foundational Web Platforms</h3>
            <div className="flex items-center gap-3 text-2xl text-gray-700 mb-4">
              <SiWix />
              <SiWordpress />
              <SiSquarespace />
            </div>
            <p className="text-gray-700 mb-6">
              Need a fast launch or something more DIY-friendly? We'll set up a beautiful site using Wix, WordPress, or Squarespace with your brand and content ready to go.
            </p>
            <p className="italic text-gray-600">
              Starts at: <span className="text-2xl  text-gray-900 not-italic ml-2">$1,500</span>
            </p>
          </div>

          {/* E-Commerce & Payment Integration */}
          <div className="bg-white p-8 text-left shadow-sm border border-gray-200">
            <h3 className="uppercase text-sm text-[#517d74] tracking-widest mb-3">Advanced E-Commerce Setup</h3>
            <div className="flex items-center gap-3 text-2xl text-gray-700 mb-4">
              <SiShopify />
              <SiWoocommerce />
            </div>
            <p className="text-gray-700 mb-6">
              Sell smarter. We'll build out your online store with custom checkout flows, product variants, and payment gateway integrations.
            </p>
            <p className="italic text-gray-600">
              Starts at: <span className="text-2xl  text-gray-900 not-italic ml-2">$2,500</span>
            </p>
          </div>

          {/* Chat Integration */}
          <div className="bg-white p-8 text-left shadow-sm border border-gray-200">
            <h3 className="uppercase text-sm text-[#517d74] tracking-widest mb-3">Live Chat & Lead Capture</h3>
            <div className="flex items-center gap-3 text-2xl text-gray-700 mb-4">
              <MessageSquare />
            </div>
            <p className="text-gray-700 mb-6">
              Connect with visitors in real time. We’ll embed chat tools like Tidio or Intercom to support sales and customer service.
            </p>
            <p className="italic text-gray-600">
              Chat Setup starts at: <span className="text-2xl  text-gray-900 not-italic ml-2">$350</span>
            </p>
          </div>

          {/* Advanced SEO */}
          <div className="bg-white p-8 text-left shadow-sm border border-gray-200">
            <h3 className="uppercase text-sm text-[#517d74] tracking-widest mb-3">Advanced SEO Strategy</h3>
            <div className="flex items-center gap-3 text-2xl text-gray-700 mb-4">
              <Search />
            </div>
            <p className="text-gray-700 mb-6">
              Want to rank higher? Our SEO packages include keyword mapping, metadata optimization, and on-page best practices.
            </p>
            <p className="italic text-gray-600">
              SEO Packages start at: <span className="text-2xl  text-gray-900 not-italic ml-2">$800/month</span>
            </p>
          </div>

          {/* Smart Review Funnel */}
          <div className="bg-white p-8 text-left shadow-sm border border-gray-200">
            <h3 className="uppercase text-sm text-[#517d74] tracking-widest mb-3">Smart Review Funnel</h3>
            <div className="flex items-center gap-3 text-2xl text-gray-700 mb-4">
              <Star />
            </div>
            <p className="text-gray-700 mb-6">
              Automatically collect and publish glowing reviews to build trust. Perfect for local or service-based brands.
            </p>
            <p className="italic text-gray-600">
              Review Funnel Setup: <span className="text-2xl  text-gray-900 not-italic ml-2">$450</span>
            </p>
          </div>

          {/* Email Marketing Setup */}
          <div className="bg-white p-8 text-left shadow-sm border border-gray-200">
            <h3 className="uppercase text-sm text-[#517d74] tracking-widest mb-3">Email Marketing Setup</h3>
            <div className="flex items-center gap-3 text-2xl text-gray-700 mb-4">
              <FaEnvelopeOpenText />
              <SiMailchimp />
              <FaChartLine />
            </div>
            <p className="text-gray-700 mb-6">
              Start building your list the right way. We'll configure your provider, design your welcome series, and connect opt-ins to your site.
            </p>
            <p className="italic text-gray-600">
              Starts at: <span className="text-2xl  text-gray-900 not-italic ml-2">$650</span>
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}
